<template>
  <div class="course-preview-page">
    <CoursePreview class="hero-section" :course="course" />

    <div v-if="course.status === 'public'" class="header-sm">
      <span class="img" :style="{ backgroundImage: `url(${$webp(`${$config.imagesUrl}/courses/${course.smallImage}`)})` }" />
      <div>
        <p class="h5">
          {{ course.name }}
        </p>
        <p>with {{ course.instructors }}</p>
      </div>
      <nuxt-link to="/signup/" class="btn-primary btn-lg" data-event="start_now.click">
        Start Course
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import CoursePreview from '@itbpbg/lms-components/src/Courses/Preview/Index';

export default {
  components: {
    CoursePreview,
  },
  async asyncData({
    $config, route, $axios, error,
  }) {
    const course = await $axios.$get(`/courses/${route.params.course}`).catch(() => false);

    if (!course) {
      return error({ statusCode: 404, message: 'Course not found' });
    }
    course.info = {};

    course.info.fullPath = `${$config.siteUrl}${route.fullPath}`;

    course.info.metaTitle = course.metaTitle;
    course.info.metaDescription = course.metaDescription;

    course.info.created = course.info.created || new Date();
    course.info.updated = course.info.updated || new Date();

    return { course };
  },
  mounted() {
    if (process.client) {
      this.handleScroll();
    }
  },
  methods: {
    handleScroll() {
      const scroll = () => {
        if (this.$store.state.layout === 'mobile') {
          return;
        }

        const smallHeader = this.$el.querySelector('.header-sm');
        if (this.$el.querySelector('.content').getBoundingClientRect().top - 100 > 0) {
          smallHeader.classList.remove('fixed');
        } else {
          smallHeader.classList.add('fixed');
        }
      };

      if (this.course.status === 'public') {
        window.addEventListener('scroll', scroll);
        this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', scroll));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header-sm {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
  bottom: -96px;
  transition: ease all var(--duration);
  color: var(--main-light);
  background: var(--main-dark-shade-1);
  height: 96px;
  display: flex;
  align-items: center;
  padding: var(--spacing-14) var(--spacing-40);

  .img {
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    width: 100px;
    height: 100%;
    border-radius: 4px;
    margin-right: var(--spacing-16);

    .tech-img {
      text-align: right;
      margin: 4px 4px 0 0;
      display: flex;
      justify-content: flex-end;

      svg {
        max-width: 11px;
      }
    }
  }

  .h5,
  p {
    margin: 0;
  }

  p {
    margin-top: var(--spacing-6);
  }

  p:not(.h5) {
    line-height: 150%;
    color: var(--main-light-shade-4);
  }

  .btn-primary {
    margin-left: auto;
  }

  &.fixed {
    bottom: 0;
    transition: ease all var(--duration);

    .btn-primary {
      padding-left: 50px;
      padding-right: 50px;
    }
  }

  @include bp($bp-mobile) {
    display: none;
  }
}
</style>
